import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { reservationKeys } from '../../constants/reservations';
export function useInvalidateReservations() {
    const queryClient = useQueryClient();
    return useCallback(() => {
        queryClient.invalidateQueries({ queryKey: reservationKeys.all });
    }, [queryClient]);
}
